import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchFeaturedDeveloper } from "../../redux/action/homeAction";
import Slider from "../../components/common/Slider";
import { useCallback, useEffect } from "react";
import Image from "../../components/general/Image";
import useIsMobile from "../../hooks/useIsMobile";
import SlideComponentSkeleton from "../../components/loader/Skeletons/SliderDeveloperCardSekeleton";
import DummyProfilePicture from "../../assets/common/DummyProfile.jpg"
import DashedChips from "../../components/common/DashedChips";

const BannerSlider = () => {
  const dispatch = useDispatch();
  const { featuredList, isFeaturedLoading } = useSelector(state => state.home);
  const isMobile = useIsMobile();
  useEffect(() => {
    if (!isFeaturedLoading) return;
    dispatch(fetchFeaturedDeveloper())
  }, [isFeaturedLoading])

  const skills = useCallback((developer) => {
    const result = developer.skills?.slice(0, 5)
    return result || []
  }, [])

  const getSliderItems = useCallback(() => {
    return Boolean(featuredList?.length) && featuredList.map((developer) =>
      <Link key={developer.id} className="block bg-[#292929] rounded-lg py-[20px] px-[10px] min-h-[250px] mt-[20px]" to={`/developer/${developer.slug}`}>
        <div className="flex items-start justify-start gap-4">
          <figure className="w-[97px] h-[97px] translate-y-[-40px]">
            <Image className="w-full h-full object-cover rounded-lg" src={developer.profile_picture || DummyProfilePicture} alt="" />
          </figure>
          <div className="">
            <h3 className="text-[1rem] font-bold flex items-center justify-start gap-2">
              <span className="capitalize">
                {developer.first_name}
              </span>
              {
                developer.country && developer.country.flag &&
                <Image className="w-[20px] h-[15px] mt-[5px]" src={developer.country.flag.file} alt="" />
              }
            </h3>
            <small className="text-[0.62rem] font-extralight text-[#D7D7D7]">{developer.specialization}</small>
          </div>
        </div>
        <div className="-mt-[15px]">
          <div className="flex flex-wrap items-center justify-center gap-2 min-h-[50px]">
            {
              skills(developer).map((skill, index) => (
                <DashedChips key={index} text={skill} />
              ))
            }
          </div>
          
          {
            developer.previous_company_logo &&
            <>
              <div className="text-center mt-[16px] mb-[8px] text-[0.6rem] text-[#8D8D8D]">PREVIOUSLY AT</div>
              <div className="">
                <Image className="w-[50%] mx-auto" src={developer.previous_company_logo} alt="" />
              </div>
            </>
          }
        </div>
      </Link>
    )
  }, [featuredList])

  return (
    <div className="px-[20px] lg:px-0">
      {
        featuredList?.length ?
        <Slider
          items={getSliderItems()}
          pagination={isMobile}
        />
        :

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 items-center justify-center gap-4">
          {
            Array.from({ length: 5 }).map((_, index) => <SlideComponentSkeleton key={index} />)
          }
        </div>
      }
    </div>
  );
};

export default BannerSlider;